module.exports = __webpack_public_path__ + "static/img/9.a89d07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/9.jpg
// module id = i41v
// module chunks = 16